import { useEffect, useState } from 'react'
import { apiSauceInstance } from 'src/services/api'
import SelectInput, { SelectOption } from '../SelectInput'

interface Props {
  name: string
  label?: string
  disabled?: boolean
}

export function useClassificacoesFrete() {
  const [options, setOptions] = useState<SelectOption[]>([])

  useEffect(() => {
    let mounted = true

    apiSauceInstance
      .get<SelectOption[]>('/lotes/classificacoes')
      .then(response => {
        if (mounted && response.ok && response.data) {
          setOptions(response.data)
        }
      })

    return () => {
      mounted = false
    }
  }, [])

  return options
}

const ClassificacaoFreteSelectInput = ({ name, label, disabled }: Props) => {
  const options = useClassificacoesFrete()

  return (
    <SelectInput
      name={name}
      label={label || 'Classificação'}
      options={options}
      disabled={disabled}
    />
  )
}

export default ClassificacaoFreteSelectInput
